// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout>.breadcrumbs{display:none}.layout h1{margin-bottom:1rem;text-align:center;font-size:1.25rem;line-height:1.75rem;font-weight:600}@media (min-width: 660px){.layout h1{margin-bottom:2rem}.layout h1{font-size:28px}}.service-favorite-country-disabled{-webkit-backdrop-filter:blur(1.5px);backdrop-filter:blur(1.5px);font-weight:600}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
